const DisconnectedWarning = () => (
  <div className='absolute top-0 left-0 z-[1000] flex h-screen w-screen items-center justify-center backdrop-blur-xs'>
    <div className='bg-warning flex h-12 w-32 animate-pulse items-center justify-center rounded text-black'>
      Reconnexion...
    </div>
  </div>
);

export default DisconnectedWarning;
